<script lang="ts">
	import { Dialog as DialogPrimitive } from 'bits-ui'
	import X from 'lucide-svelte/icons/x'

	import { cn, flyAndScale } from '$lib/utils/shadcn'

	import * as Dialog from './index'

	type $$Props = DialogPrimitive.ContentProps

	let className: $$Props['class'] = undefined
	export let transition: $$Props['transition'] = flyAndScale
	export let transitionConfig: $$Props['transitionConfig'] = {
		duration: 200,
	}
	export { className as class }
</script>

<Dialog.Portal>
	<Dialog.Overlay />

	<DialogPrimitive.Content
		class={cn(
			'bg-background fixed top-1/2 left-1/2 z-50 flex max-h-[calc(100svh-10px)] w-[calc(100%-10px)] max-w-lg -translate-x-1/2 -translate-y-1/2 flex-col gap-4 border p-6 shadow-lg sm:rounded-lg',
			className
		)}
		{transition}
		{transitionConfig}
		{...$$restProps}
	>
		<slot />

		<DialogPrimitive.Close
			class="ring-offset-background focus-visible:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none"
			aria-label="Close"
		>
			<X class="h-4 w-4" size="16" />
		</DialogPrimitive.Close>
	</DialogPrimitive.Content>
</Dialog.Portal>
